import { createRoute } from "@tanstack/react-router";
import { searchProviderRoute } from "../$searchProviderRoute";
import { SearchInput } from "./SearchInput";

/**
 * A sibling of `layoutRoute` rather than a child, so `SearchInput` renders
 * *outside* `MainLayout` - no header, no sidebar, no sticky cart bar competing
 * for the screen with the on-screen keyboard. See `SearchInput` for why phone
 * search is a route at all.
 */
export const searchInputRoute = createRoute({
  getParentRoute: () => searchProviderRoute,
  path: "/search/input",
  component: SearchInput
});
